import posthog from 'posthog-js';
import { User } from 'components/User/types';
import { formatUserId } from 'components/PostHog/utils';
import { PosthogEvents, PosthogActions } from './PosthogEvents';

interface TrackVisitParams {
  user: User | null;
  page: string;
}

function trackPageVisit(params: TrackVisitParams) {
  const { user, page } = params;

  if (user) {
    posthog.capture(PosthogEvents.UserActions, {
      action: PosthogActions.PageNavigation,
      page,
      userId: user.id ? formatUserId(user.id) : undefined,
    });
  }
}

function trackPageLoad(params: TrackVisitParams) {
  const { user, page } = params;

  if (user) {
    posthog.capture(PosthogEvents.UserActions, {
      action: PosthogActions.PageLoad,
      page,
      userId: user.id ? formatUserId(user.id) : undefined,
    });
  }
}

export { trackPageVisit, trackPageLoad };
